import * as React from 'react';
import initializeComponent from './react-initialize';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './chakraTheme';

export function Initializer(Component: any) {
   return (props: any) => (
      <ChakraProvider theme={theme} resetCSS={false}>
         <Component {...props} />
      </ChakraProvider>
   );
}

export function initializeChakraComponent(name: any, Component: any, defaultProps = {}) {
   initializeComponent(name, Initializer(Component), defaultProps);
}
